import PCOInvoiceTable from "./PCOInvoiceTable";

export default PCOInvoiceTable;